/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import {
  VIEW_SCHEDULER,
  VIEW_TRUCKING_LC,
  VIEW_WAREHOUSE_LC,
  VIEW_ADMIN,
  VIEW_CMS_PRICING,
  VIEW_PRICING_INBOX,
  VIEW_ORGANIZATIONS,
  VIEW_PRICING_ADMIN,
  VIEW_WAREHOUSE_APP,
  VIEW_DISPATCHING,
  VIEW_CLAIMS,
  VIEW_REPAIR_ORDER,
  USE_MESSAGING,
  // Quotes
  QUOTES_READ,
  // Safety
  SAFETY_READ_ONLY,
  SAFETY_MANAGER,
  SAFETY_DISPATCHER_ACCESS,
} from 'shared/../constants/UserAccess';
import {
  BsSearch, BsClipboardData, BsGrid, BsTruckFlatbed, BsClockHistory, BsUpload, BsPeopleFill, BsCalculator, BsGraphUp,
} from 'react-icons/bs';

const navigation = [
  {
    userAccess: VIEW_CMS_PRICING,
    path: 'pricing',
    icon: 'money-bill',
    text: 'Pricing',
    subNav: [
      { path: 'dashboard', text: 'Pricing Dashboard' },
      { userAccess: VIEW_PRICING_INBOX, path: 'requests', text: 'Requests' },
      { userAccess: QUOTES_READ, path: 'quotes', text: 'Quotes' },
      { userAccess: VIEW_CMS_PRICING, path: 'invoice-line-item-types', text: 'Invoice Line Item Types' },
      { userAccess: VIEW_CMS_PRICING, path: 'ratezones', text: 'Rate Zones' },
      { userAccess: VIEW_CMS_PRICING, path: 'standard-fuel-tariffs', text: 'Standard Fuel Tariffs' },
      { userAccess: VIEW_PRICING_ADMIN, path: 'direct-standards', text: 'Direct Standards' },
      { userAccess: VIEW_PRICING_ADMIN, path: 'rates-uploader', text: 'Rates Uploader', icon: <BsUpload /> },
      { userAccess: VIEW_PRICING_ADMIN, path: 'quick-rate', text: 'Quick Rate', icon: <BsCalculator /> },
    ],
  },
  {
    userAccess: [VIEW_SCHEDULER, VIEW_TRUCKING_LC, VIEW_WAREHOUSE_LC],
    path: 'scheduling',
    icon: 'available',
    text: 'Scheduling',
    subNav: [
      { userAccess: VIEW_SCHEDULER, path: 'dashboard', text: 'Scheduling Dashboard' },
      { userAccess: VIEW_SCHEDULER, path: 'scheduler', text: 'Scheduler' },
      { userAccess: VIEW_SCHEDULER, path: 'scheduler-v1', text: 'Scheduler v1' },
      { userAccess: VIEW_SCHEDULER, path: 'lane-capacity', text: 'Lane Capacity' },
      { path: 'lc', text: 'Logistics Coordinator' },
      { path: 'history', text: 'History' },
      { userAccess: VIEW_SCHEDULER, path: 'scheduling-terminals', text: 'Scheduling Terminals' },
      { path: 'customer-capacity', text: 'Customer Capacity' },
      { path: 'scheduling-history', text: 'Scheduling History', icon: <BsClockHistory /> },
      { path: 'forecast', text: 'Forecast', icon: <BsGraphUp /> },
    ],
  },
  {
    userAccess: [SAFETY_READ_ONLY, SAFETY_DISPATCHER_ACCESS],
    path: 'safety',
    icon: 'safety',
    text: 'Safety',
    subNav: [
      { path: 'dashboard', text: 'Safety Dashboard', icon: <BsClipboardData /> },
      {
        path: 'search', text: 'Search', icon: <BsSearch />, userAccess: SAFETY_READ_ONLY,
      },
      { path: 'drivers', text: 'Drivers' },
      { path: 'trucks', text: 'Trucks' },
      { path: 'driver-truck-assignments', text: 'Driver/Truck Assignments', userAccess: SAFETY_READ_ONLY },
      { path: 'owners', text: 'Owners', userAccess: SAFETY_READ_ONLY },
      {
        userAccess: SAFETY_MANAGER,
        path: 'safety-table-maints',
        text: 'Safety Table Maints',
        icon: <BsGrid />,
      },
      { path: 'permit-locations', text: 'Permit Locations' },
      { path: 'maintenance-reports', text: 'Maintenance Reports' },
      { path: 'driver-uploads', text: 'Driver Uploads', icon: <BsUpload /> },
    ],
  },
  {
    userAccess: VIEW_CLAIMS,
    path: 'risk',
    icon: 'clipboard-list',
    text: 'Risk',
    subNav: [
      { path: 'insurance', text: 'Insurance' },
    ],
  },
  {
    userAccess: VIEW_REPAIR_ORDER,
    path: 'maintenance',
    icon: 'wrench1',
    text: 'Maintenance',
    bypassLanding: true,
    subNav: [
      { path: 'repair-orders', text: 'Repair Orders' },
      { path: 'repair-issues', text: 'Repair Issues' },
      { path: 'repair-categories', text: 'Repair Categories' },
      { path: 'gwi-equipment', text: 'GWI Equipment' },
      { userAccess: VIEW_PRICING_ADMIN, path: 'equipment-types', text: 'Equipment Types' },
    ],
  },
  {
    userAccess: VIEW_ORGANIZATIONS,
    path: 'organizations',
    icon: 'organization',
    text: 'Organizations',
    subNav: [
      { path: 'organizations', text: 'Organizations' },
      { path: 'organizations-mapping', text: 'Legacy Organizations Mapping' },
      { path: 'locations', text: 'Locations' },
      { path: 'contacts', text: 'Contacts' },
      { path: 'fuel-tariffs', text: 'Fuel Tariffs' },
      { path: 'per-diem-standard-tariffs', text: 'Per Diem Standard Tariffs' },
      { path: 'per-diem-contract-rules', text: 'Per Diem Contract Rules' },
    ],
  },
  {
    userAccess: VIEW_ADMIN,
    path: 'admin',
    icon: 'user-cog',
    text: 'Admin',
    subNav: [
      {
        path: 'admin',
        text: 'Admin Table Maints',
        icon: <BsGrid />,
      },
      { path: 'reports', text: 'Reports' },
      { path: 'scaffolding-dashboard', text: 'Scaffolding Dashboard' },
      { path: 'table-maints', text: 'Admin Table Maints' },
      { path: 'notifications', text: 'Notifications' },
      { path: 'equipment-types-management', text: 'Equipment Types Management' },
    ],
  },
  {
    path: 'messaging',
    target: '_blank',
    icon: 'comment-alt-lines',
    text: 'Messaging',
    userAccess: USE_MESSAGING,
  },
  {
    userAccess: VIEW_DISPATCHING,
    path: 'dispatching-v1',
    icon: 'dispatch',
    text: 'Dispatching v1',
    bypassLanding: true,
    subNav: [
      { path: 'dispatch-planner', text: 'Dispatch Planner' },
      { path: 'gwi-equipment', text: 'GWI Equipment' },
      { path: 'messaging-metrics', text: 'Messaging Metrics' },
    ],
  },
  {
    userAccess: VIEW_WAREHOUSE_APP,
    path: 'warehouse/v1',
    icon: 'person-dolly',
    text: 'Warehouse v1',
    subNav: [
      { path: 'dashboard', text: 'Warehouse Dashboard' },
      { path: 'loads', text: 'Loads' },
      { path: 'clerking', text: 'Clerking Options' },
    ],
  },
];

export default navigation;